import React from 'react';
import { Layout } from 'components';
import styled from 'styled-components/macro';
import { renderBodyHtml } from 'components/common/renderBodyHtml';
import { useParams } from 'react-router-dom';

const AdminPage = () => {
  const { boardType } = useParams<{ boardType: string }>();
  const src =
    boardType === 'productivity'
      ? process.env.REACT_APP_DASHBOARD_PRODUCTIVITY_URL
      : process.env.REACT_APP_DASHBOARD_REALTIME_TRACKING_URL;
  return (
    <Layout pageName="Dashboard">
      {src ? (
        <SContent>
          {renderBodyHtml(
            `<iframe width="100%" height="100%" src="${src}" frameborder="0" style="border:0" allowfullscreen></iframe>`,
          )}
        </SContent>
      ) : (
        <SErrorMessage>
          {boardType} dashboard is not available yet.
        </SErrorMessage>
      )}
    </Layout>
  );
};

export default AdminPage;
const SErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 30px;
  color: #8f8f8f;
`;
const SContent = styled.div`
  & > * {
    height: 100%;
  }
  height: 85vh;
  padding: 1rem;
`;
